// Enums
import {StatusCode} from '../enums/StatusCode'

// Axios
import {AxiosResponse} from 'axios'

export class ApiResponse<T> {

    public static async createResponse<T>(response: AxiosResponse<ApiResponse<T>>): Promise<ApiResponse<T>> {
        try {

            const status = response.status
            const headers = response.headers

            if (status >= 300) {

                throw new ApiResponse({
                    status,
                    headers,
                    success: false,
                    body: <any>response.data,
                    error: response.data ? response.data.error : undefined
                })
            }

            return new ApiResponse<T>({
                status,
                headers,
                success: response.data && response.data.success ? response.data.success : undefined,
                body: response.data && response.data.body ? response.data.body : <any>response.data,
            })
        } catch(err) {

            if (err instanceof ApiResponse) {
                throw err
            }

            throw new ApiResponse({
                status: StatusCode.PARSE_ERROR
            })
        }
    }

    public status!: StatusCode
    public headers?: any
    public success?: boolean
    public body?: T
    public error?: any

    constructor(init?: Partial<ApiResponse<T>>) {
        Object.assign(this, init);
    }
}